/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Same_Email_QInputs */



/**
* | output |
* | --- |
* | "Why do I have more than one account with the same email?" |
*
* @param {Partner_Faq_Same_Email_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_same_email_q = /** @type {((inputs?: Partner_Faq_Same_Email_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Same_Email_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warum habe ich mehr als ein Konto mit derselben E-Mail-Adresse?")
	return /** @type {LocalizedString} */ ("Why do I have more than one account with the same email?")
});